import React, { Component } from 'react'
import { EmptyState, SearchWithAction, Page, Table, CardBox, DropdownButton } from '../../components'
import { connect } from 'react-redux'
import { getProjectMembers, deleteUser } from '../../api';
import { notify, testRegex } from '../../utils'
import { push } from '../../actions/nav-actions';
import Loader from '../../components/Loader';

class Directory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query: '',
            members: []
        }
        this.renderChild = this.renderChild.bind(this);
    }
    renderEmpty() {
        return (
            // <EmptyState
            //     title="Empty users"
            //     message="Nothing to show to you here, maybe change your search or reload the page." />
            <Loader />
        )
    }
    renderChild() {
        return (
            [
                { Header: 'Name', accessor: 'name' },
                { Header: 'Email', accessor: 'email' },
                {
                    Header: 'Registered Organizations',
                    id: 'cellOrganizations',
                    accessor: d => d.organizations.map(o => o.name).join(', ')
                },
                {
                    Header: 'Options',
                    accessor: d => d,
                    className: "no-overflow",
                    id: 'options',
                    Cell: props => (
                        <DropdownButton
                            icon="mdi mdi-account-settings"
                            label="Options">
                            <DropdownButton.Option
                                onClick={() => this.props.push(`/users/${props.value._id}`)}
                                icon="mdi mdi-pencil"
                                label="Edit" />
                            <DropdownButton.Option
                                onClick={() => {
                                    let confirm = window.confirm('Really wants to delete user ' + props.value.user.name + '?');
                                    if (confirm) {
                                        deleteUser(this.props.user.token, props.value._id)
                                            .then((user) => this.props.retrieve(this.props.user.token))
                                            .catch((err) => notify(err.message))
                                    }
                                }}
                                icon="mdi mdi-delete"
                                label="Delete" />
                        </DropdownButton>
                    )
                }
            ]
        )
    }
    componentDidMount() {
        const params = this.props.match.params || {};
        getProjectMembers(
            this.props.user.token,
            params.organization,
            params.code
        )
            .then((members) => this.setState({ members }))
            .catch(err => notify('Error', err.message, 'error'))
    }
    render() {
        let results = this.state.members.filter(i => testRegex(i.name, this.state.query));
        return (
            <Page title="Directory">
                <SearchWithAction
                    action="ADD USERS"
                    onActionClick={() => this.props.push(`/projects/${this.props.match.params.organization}/${this.props.match.params.code}/members`)}
                    onChange={query => this.setState({ query })} />
                <CardBox>
                    <Table
                        id="project-directory"
                        renderEmpty={this.renderEmpty}
                        data={results}
                        columns={this.renderChild()} />
                </CardBox>
            </Page>
        )
    }
}

const mapStateToProps = s => ({ user: s.authReducer.user });

const mapDispatchToProps = dispatch => ({
    push(routeName) {
        dispatch(push(routeName))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Directory);


// WEBPACK FOOTER //
// ./src/routers/Projects/Directory.js